import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Icon,
  Select,
  Message,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import { REINSTATEMENT_REASONS } from '../../constants';

class GuaranteeReinstate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelledPurchaseId: null,
      reinstatementReason: null,
      bypassCharge: false,
      silent: false,
      errors: {},
    };
  }

  componentDidMount() {
    const { cancelledPurchase } = this.props;
    const { id } = cancelledPurchase;

    this.setState({ cancelledPurchaseId: id });
  }

  render() {
    const {
      cancelledPurchase,
      isReinstateModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      errors,
      reinstatementReason,
      silent,
      bypassCharge,
    } = this.state;

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
    };

    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const validationRules = {
      reinstatementReason: 'required',
    };

    const submitForm = () => {
      const {
        cancelledPurchaseId,
        reinstatementReason: reason,
        bypassCharge: bypass,
        silent: isSilent,
      } = this.state;

      const validation = new Validator(this.state, validationRules);

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        cancelledPurchaseId,
        reinstatement: {
          reinstatementReason: reason,
          bypassCharge: bypass,
          silent: isSilent,
        },
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isReinstateModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>
          Reinstate Guarantee Purchase for VIN {cancelledPurchase.vin}
        </Modal.Header>

        <Modal.Content image>
          <Modal.Description>
            {error && (
            <Message negative>
              <p>{error}</p>
            </Message>
            )}
            <Form widths='equal'>
              <Form.Field
                required
                error={!isEmpty(errors.reinstatementReason)}
              >
                <label htmlFor='reinstatementReason'>Reason</label>
                <Select
                  id='reinstatementReason'
                  placeholder='Select reinstatement reason'
                  options={REINSTATEMENT_REASONS}
                  closeOnBlur
                  value={reinstatementReason}
                  onChange={onSelectHandler('reinstatementReason')}
                />
                {errors.reinstatementReason && (
                <span>{errors.reinstatementReason}</span>
                )}
              </Form.Field>
              <Form.Group widths='equal'>
                <Form.Field>
                  <Checkbox
                    label='Skip sending purchase confirmation'
                    checked={silent}
                    onChange={onCheckboxHandler('silent')}
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    label='Bypass Charge'
                    checked={bypassCharge}
                    onChange={onCheckboxHandler('bypassCharge')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
          <Button loading positive>
            Submitting...
          </Button>
          )}
          {!submitting && (
          <Button color='green' onClick={submitForm} inverted>
            <Icon name='checkmark' /> Submit
          </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

GuaranteeReinstate.propTypes = {
  cancelledPurchase: PropTypes.shape({
    id: PropTypes.number,
    vin: PropTypes.string,
  }).isRequired,
  isReinstateModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

export default GuaranteeReinstate;
